import type { ShapeProps } from "./index";

export function Cylinder({ width, height, ...svgAttributes }: ShapeProps) {
  const bend = height * 0.125;
  const d = [
    `M0,${bend}`,
    `L0,${height - bend}`,
    `A${width / 2},${bend} 0 1 0 ${width},${height - bend}`,
    `L${width},${bend}`,
    `A${width / 2},${bend} 0 1 1 0,${bend}`,
    `A${width / 2},${bend} 0 1 1 ${width},${bend}`,
    `A${width / 2},${bend} 0 1 1 0,${bend}`,
    "Z",
  ].join(" ");

  return <path d={d} {...svgAttributes} />;
}
